import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import global from "@/utils/global";
import regexp from "@/utils/regexp";
import filters from "@/filters/index";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.bubble.css';
import 'quill/dist/quill.snow.css';
import VueQuillEditor from "vue-quill-editor";
import "amfe-flexible";
import md5 from "js-md5";

//全局样式
import "./assets/css/reset.css";

Vue.use(require("vue-wechat-title"));

//引入过滤器
Vue.use(filters);

Vue.use(VueQuillEditor);
;
Vue.config.productionTip = false;
Vue.prototype.$global = global;
Vue.prototype.$regexp = regexp;
Vue.prototype.$md5 = md5;


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
